import React, { useEffect } from 'react';
import { Routes, Navigate, Route, useParams } from 'react-router-dom';

import {
  OverlayLoader,
  NotFound,
  BillingInformationModalContext,
  usePlanId,
} from 'components';

import {
  AnalyticsCategoryProvider,
  Categories,
  reverseCrisp,
} from '@app/analytics';
import { useSession } from 'queries';
import { useEditSessionSteps } from './steps';
import { EditSessionAdmin } from './EditSessionAdmin';

export const EditSession = () => {
  const { id } = useParams();
  const { data: session, isLoading } = useSession(id);
  usePlanId(session?.planId);
  const { steps, isLoading: isStepsLoading } = useEditSessionSteps(session);

  useEffect(() => {
    reverseCrisp(true);
    return () => {
      reverseCrisp(false);
    };
  }, []);

  if (isLoading || isStepsLoading) {
    return <OverlayLoader />;
  } else if (!session) {
    return <NotFound />;
  }

  return (
    <AnalyticsCategoryProvider category={Categories.EDIT_STUDY} sessionId={id}>
      <BillingInformationModalContext session={session} showAllPriceInfo>
        <Routes>
          {steps.map((step) => (
            <Route
              path={step.path}
              key={step.name}
              element={step.getElement({ session })}
            />
          ))}
          <Route
            path="admin"
            element={<EditSessionAdmin session={session} />}
          />
          <Route path="*" element={<Navigate to="review" replace />} />
        </Routes>
      </BillingInformationModalContext>
    </AnalyticsCategoryProvider>
  );
};
